import React from "react";
import { PaymentButtons } from "./PaymentButtons";
export function Offer() {
  return <section id="unirme" className="bg-ink-2" data-id="element-83" data-mp="17z5x2gk9rwjy">
      <div className="mx-auto max-w-5xl px-6 py-16 text-center sm:py-24" data-id="element-84" data-mp="17y34m47atm1x">
        <p className="mb-3 font-semibold text-accent" data-id="element-85" data-mp="1mmh8miggbgk2">Etapa fundadora activa</p>
        <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-86" data-mp="1hnw8ej178wvm">
          Entrá a Radar Digital con precio fundador
        </h2>
        <div className="mx-auto max-w-2xl rounded-2xl border border-accent/40 bg-ink p-6 sm:p-10" data-id="element-87" data-mp="u0xsbmgzrqy8">
          <p className="mb-6 leading-relaxed text-soft" data-id="element-88" data-mp="p1uzd0eadb6m">
            Formación para crear y vender tu ebook + comunidad en Skool + dos asesorías semanales, miércoles y viernes.
          </p>
          <p className="font-serif text-4xl font-bold text-accent" data-id="element-89" data-mp="ywmxc5bs601x">
            USD 27<span className="font-sans text-base font-normal text-soft" data-id="element-90" data-mp="2fav6my7jicvm">/mes</span>
          </p>
          <p className="mt-3 text-2xl font-semibold" data-id="element-91" data-mp="2ac1ub93zorx1">ARS 40.000/mes</p>
          <p className="mt-2 text-sm text-soft" data-id="element-92" data-mp="pkh3z3r2mici">Pago en pesos para Argentina, mediante Mercado Pago.</p>
          <p className="my-6 border-y border-line py-5 leading-relaxed text-soft" data-id="element-93" data-mp="uisfrk0xf2xd">
            Futuro precio de ingreso:
            <br data-id="element-94" data-mp="zjg7k7wzbnsn" />
            <strong className="text-white" data-id="element-95" data-mp="ziwmiic18jae">USD 97/mes o ARS 150.000/mes</strong>
          </p>
          <p className="mb-6 leading-relaxed text-soft" data-id="element-96" data-mp="13jgjnlwlvmwj">
            Esta condición especial está disponible durante la etapa fundadora de la comunidad.
          </p>
          <PaymentButtons data-id="element-97" data-mp="bsao7irtyddl" />
          <p className="mt-5 text-sm leading-relaxed text-soft" data-id="element-98" data-mp="btlvvtoec59z">
            Membresía mensual con renovación automática. Podés cancelar desde la plataforma donde te suscribiste.
          </p>
        </div>
      </div>
    </section>;
}